module.exports = __webpack_public_path__ + "static/assets/11b07422894b0bb5cc43fafce2055564.svg";